import React, { createContext, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { NotFound } from '@js/components/errors/NotFound';
import { ScrollToTop } from '@js/components/common/ScrollToTop';
import { routes, snsAuthRoutes } from './routes';
type ContextType = {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isEdit: boolean;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  isSubmitting: boolean;
  setIsSubmitting: React.Dispatch<React.SetStateAction<boolean>>;
  shouldSkipCompatibility: boolean;
  setShouldSkipCompatibility: React.Dispatch<React.SetStateAction<boolean>>;
};

const initialState: ContextType = {
  isLoading: false,
  setIsLoading: () => undefined,
  isEdit: false,
  setIsEdit: () => undefined,
  isSubmitting: false,
  setIsSubmitting: () => undefined,
  shouldSkipCompatibility: false,
  setShouldSkipCompatibility: () => undefined,
};

export const Context = createContext(initialState);

export const RegistrationRouter = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [shouldSkipCompatibility, setShouldSkipCompatibility] = useState<boolean>(false);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Context.Provider value={{ isLoading, setIsLoading, isEdit, setIsEdit, isSubmitting, setIsSubmitting, shouldSkipCompatibility, setShouldSkipCompatibility }}>
        <Routes>
          {routes.map((route) => {
            const fullPath = `/corporate_registration${route.path === '/' ? '' : route.path}`;
            return (
              <Route
                key={route.path}
                path={fullPath}
                element={route.children}
              />
            );
          })}
          {snsAuthRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.children}
            />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Context.Provider>
    </BrowserRouter>
  );
};

export const LoginRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {snsAuthRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={route.children}
          />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
